import { render, staticRenderFns } from "./LTA.vue?vue&type=template&id=08c6215a&scoped=true&"
import script from "./LTA.vue?vue&type=script&lang=ts&"
export * from "./LTA.vue?vue&type=script&lang=ts&"
import style0 from "./LTA.vue?vue&type=style&index=0&id=08c6215a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c6215a",
  null
  
)

export default component.exports